import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import ErrorIcon from '@mui/icons-material/Error';
import { red } from '@mui/material/colors';
import config from '../../../config';

interface DialogContentErrorProps {
  errorText: string;
}

const DialogContentError: React.FC<DialogContentErrorProps> = ({ errorText }) => {
  const spaceUrl: string = config.gChatSupportSpace;

  return (
    <Box>
      <ErrorIcon sx={{ fontSize: 50, color: red[500], marginTop: 1 }} />
      <Typography variant="body1">Oops! We couldn't process your request.</Typography>
      {errorText && (
        <Typography variant="body1" sx={{ color: red[500], fontWeight: 'bold', margin: 1 }}>
          Error: {errorText}
        </Typography>
      )}
      <Typography variant="body1">
        Please try again later, or contact support via{' '}
        <Link href={spaceUrl} target="_blank" rel="noopener noreferrer" underline="hover">
          #ncc-support
        </Link>{' '}
        for further assistance.
      </Typography>
    </Box>
  );
};

export default DialogContentError;
